module.exports = (__webpack_require__(9))(324);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/pagination/index.js from dll-reference antd_library
// module id = 957
// module chunks = 42